import { Skeleton } from '@/components/ui';

export default function AboutEventSkeleton(): React.ReactNode {
  return (
    <div className='mt-10'>
      <Skeleton className='mt-6 h-8 w-full rounded-md bg-gray-200' />
      <Skeleton className='mt-3 h-8 w-full rounded-md bg-gray-200' />
      <Skeleton className='mt-3 h-8 w-full rounded-md bg-gray-200' />
      <Skeleton className='mt-3 h-8 w-full rounded-md bg-gray-200' />
    </div>
  );
}
